export default function Benefits() {
  const benefits = [
    {
      category: 'Health & Wellness',
      icon: 'ri-heart-pulse-line',
      items: [
        'Comprehensive health insurance',
        'Dental and vision coverage',
        'Mental health support',
        'Gym membership discounts'
      ]
    },
    {
      category: 'Financial',
      icon: 'ri-money-dollar-circle-line',
      items: [
        'Competitive salary packages',
        'Performance bonuses',
        'Retirement savings plans',
        'Stock options for senior roles'
      ]
    },
    {
      category: 'Time Off',
      icon: 'ri-calendar-check-line',
      items: [
        '25 days paid vacation',
        'Paid parental leave',
        'Flexible holidays',
        'Sabbatical opportunities'
      ]
    },
    {
      category: 'Professional Development',
      icon: 'ri-graduation-cap-line',
      items: [
        'Training and certifications',
        'Conference attendance',
        'Mentorship programs',
        'Tuition reimbursement'
      ]
    },
    {
      category: 'Work Flexibility',
      icon: 'ri-home-office-line',
      items: [
        'Remote work options',
        'Flexible hours',
        'Hybrid arrangements',
        'Co-working space access'
      ]
    },
    {
      category: 'Perks & More',
      icon: 'ri-gift-line',
      items: [
        'Free shipping discounts',
        'Team building events',
        'Employee referral bonuses',
        'Relocation assistance'
      ]
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Benefits & Perks
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We invest in our people with comprehensive benefits designed to support your health, growth, and happiness.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="border border-gray-200 rounded-xl p-8 hover:border-blue-300 transition-colors"
            >
              <div className="flex items-center gap-4 mb-6">
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                  <i className={`${benefit.icon} text-xl text-green-600`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900">
                  {benefit.category}
                </h3>
              </div>
              <ul className="space-y-3">
                {benefit.items.map((item, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <i className="ri-check-line text-green-600 mt-1"></i>
                    <span className="text-gray-600">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
